export enum ReserveTypes {
  NATURE_RESERVE = 'NatureReserve',
  REGION = 'Region'
}

export enum PolygonTypes {
  RADIUS = 'radius',
  POLYGON = 'polygon'
}
